import React from "react";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { renderTimeViewClock } from "@mui/x-date-pickers/timeViewRenderers";
import { useLocation } from "react-router-dom";
import dayjs from "dayjs";

const TimeandDate = ({
  blockFuture,
  labelName,
  id,
  placeholder,
  value,
  error,
  onChange,
  format,
  name,
}) => {
  const location = useLocation();
  let isBlock;
  if (blockFuture) {
    isBlock = dayjs(blockFuture);
  }

  return (
    <div>
      {location.pathname === "/summary" ? null : (
        <label className="input-label my-1">
          {labelName}
          <span style={{ color: "red" }}>*</span>
        </label>
      )}
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DemoContainer components={["DateTimePicker"]}>
          <DateTimePicker
            disablePast
            minDateTime={isBlock} // Disable dates before `isBlock`
            defaultValue={new Date()} // Set default value to current date and time
            label={placeholder}
            viewRenderers={{
              hours: renderTimeViewClock,
              minutes: renderTimeViewClock,
              seconds: renderTimeViewClock,
            }}
            slotProps={{
              textField: {
                size: "small",
                error: error,
                readOnly: true,
              },
            }}
            value={value}
            onChange={onChange}
            format={format}
            name={name}
            id={id}
          />
        </DemoContainer>
      </LocalizationProvider>
    </div>
  );
};

export default TimeandDate;
